"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const colors_1 = require("@material-ui/core/colors");
const Info_1 = __importDefault(require("@material-ui/icons/Info"));
const classnames_1 = __importDefault(require("classnames"));
const lodash_1 = require("lodash");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const usehooks_ts_1 = require("usehooks-ts");
const apiActions = __importStar(require("api-actions"));
const components_1 = require("components");
const config_1 = require("config");
const merchant_management_v1_api_1 = require("merchant-management-v1-api");
const merchant_portal_components_1 = require("merchant-portal-components");
const utils_1 = require("utils");
const reducer_1 = require("../../reducer");
const components_2 = require("../components");
function AccountLookUpDetail({ currentLocation, getLenderSettings, lenderSettings, }) {
    const history = (0, react_router_dom_1.useHistory)();
    const { id } = (0, react_router_dom_1.useParams)();
    const [saleInitiatorAccountMemberId, setSaleInitiatorAccountMemberId] = (0, react_1.useState)(0);
    const [salesTransactionsRendered, setSalesTransactionsRendered] = (0, react_1.useState)(10);
    const [refundTransactionsRendered, setRefundTransactionsRendered] = (0, react_1.useState)(0);
    const [hasUpdatedLenderSettings, setHasUpdatedLenderSettings] = (0, react_1.useState)(false);
    const { data: accountDetail, refetch } = (0, merchant_management_v1_api_1.useGetMerchantManagementV1LookupsAccountsAlphaeonAccountNumberQuery)({
        alphaeonAccountNumber: id ?? '',
        locationId: String(currentLocation.locationId),
    });
    const { isIntersecting: isIntersectingSales, ref: salesIntersection } = (0, usehooks_ts_1.useIntersectionObserver)();
    const { isIntersecting: isIntersectingRefunds, ref: refundsIntersection } = (0, usehooks_ts_1.useIntersectionObserver)();
    const [accountLenderName, setAccountLenderName] = (0, react_1.useState)(undefined);
    const reloadFunc = () => {
        refetch();
    };
    (0, react_1.useEffect)(() => {
        if (isIntersectingSales &&
            salesTransactions &&
            salesTransactionsRendered < salesTransactions.length) {
            setSalesTransactionsRendered(salesTransactionsRendered + 10);
        }
    }, [isIntersectingSales]);
    (0, react_1.useEffect)(() => {
        if (isIntersectingRefunds &&
            refundTransactions &&
            refundTransactionsRendered < refundTransactions.length) {
            setRefundTransactionsRendered(refundTransactionsRendered + 10);
        }
    }, [isIntersectingRefunds]);
    (0, react_1.useEffect)(() => {
        if (accountDetail) {
            refetch();
        }
    }, [id, currentLocation, saleInitiatorAccountMemberId]);
    (0, react_1.useEffect)(() => {
        setAccountLenderName(accountDetail?.lenderName);
    }, [accountDetail]);
    (0, react_1.useEffect)(() => {
        async function fetchLenderSettings() {
            if (accountLenderName) {
                await getLenderSettings(accountLenderName, currentLocation.locationId);
                setHasUpdatedLenderSettings(true);
            }
        }
        fetchLenderSettings();
    }, [accountLenderName, hasUpdatedLenderSettings]);
    (0, react_1.useEffect)(() => {
        if (accountDetail) {
            (0, utils_1.reportAction)('AccountLookupDetail', {
                componentName: 'AccountLookupDetail',
                actionType: 'View',
                actionURL: window.location.pathname,
                actionData: {
                    alphaeonAccountNumber: accountDetail.alphaeonAccountNumber,
                    locationStoreNumber: currentLocation.adsStoreNumber.toString(),
                    locationId: currentLocation.locationId,
                },
            });
        }
    }, [accountDetail]);
    if (!accountDetail || !hasUpdatedLenderSettings) {
        return (0, jsx_runtime_1.jsx)(components_1.Spinner, { centerPage: true });
    }
    const { name, email, alphaeonAccountNumber, dateOfBirth, address, availableCreditLimit, creditLimit, ssnLast4, primaryPhone, authorizedBuyers, consumerCreditInstrumentType, transactions, accountMemberId, derogatoryInd, internalRiskReason, lenderName, lenderEnabled, alternatePhone, createdAt, downpaymentRequired, expiresAt, serviceDate, } = accountDetail;
    const salesTransactions = transactions &&
        transactions
            .filter(({ status, transactionType }) => transactionType === 'sale' &&
            status !== config_1.TRANSACTION_STATUS.ENTERED &&
            status !== config_1.TRANSACTION_STATUS.SETTLED &&
            status !== config_1.TRANSACTION_STATUS.SENT_FOR_SETTLEMENT)
            .sort((a, b) => {
            return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
        });
    const refundTransactions = transactions &&
        assemble(transactions
            .filter(({ status, transactionType }) => ((transactionType === 'sale' || transactionType === 'loan') &&
            config_1.REFUNDABLE_STATES.includes(status)) ||
            transactionType === 'refund' ||
            transactionType === 'loan_refund')
            .sort((a, b) => {
            return (new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
        }));
    const isServiceDateInFuture = (value) => {
        const newDate = new Date();
        const today = new Date(newDate);
        today.setDate(newDate.getDate() - 1);
        return new Date(value) > today;
    };
    const voidTransaction = ({ alphaeonAccountNumber, creditLimit, name, transaction, }) => history.push({
        pathname: `${config_1.VOID_SALE_URL}${alphaeonAccountNumber}`,
        state: {
            alphaeonAccountNumber,
            creditLimit,
            name,
            transaction,
        },
    });
    const refundTransaction = ({ alphaeonAccountNumber, creditLimit, name, transaction, }) => history.push({
        pathname: `${config_1.REFUND_REQUEST_URL}${alphaeonAccountNumber}`,
        state: {
            accountMemberId,
            alphaeonAccountNumber,
            creditLimit,
            name,
            transaction,
            consumerCreditInstrumentType,
        },
    });
    const lenderCanProcessSale = lenderName != 'Covered Care';
    const showSaleInText = lenderSettings?.lenderProductType != 'LTO';
    const CREDIT_TEXT = showSaleInText ? 'Available Credit' : 'Available Amount';
    const CREDIT_LIMIT_TEXT = showSaleInText ? 'Credit Limit' : 'Account Limit';
    const productTypeMap = {
        Imprint: 'Advantage',
        AFF: 'Access',
        ADS: 'AC Prime',
    };
    const productType = productTypeMap[lenderName];
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "account-lookup", children: [(0, jsx_runtime_1.jsx)(components_1.H1, { children: "Account Summary" }), (0, jsx_runtime_1.jsxs)("div", { className: "account-summary summary", children: [(0, jsx_runtime_1.jsxs)("div", { className: "card-border pad-t-15 pad-30", children: [(0, jsx_runtime_1.jsxs)(components_1.H2, { variant: "headline-medium", className: "card-title", children: [name?.firstName, " ", name?.lastName] }), (0, jsx_runtime_1.jsxs)("div", { className: "w100 flex dir-row justify-between", children: [(0, jsx_runtime_1.jsx)(DetailColumn, { fields: [
                                                    {
                                                        label: 'Date of Birth',
                                                        value: dateOfBirth
                                                            ? (0, utils_1.formatISODateStringAsUSMonthDayYear)(dateOfBirth)
                                                            : 'N/A',
                                                        show: true,
                                                    },
                                                    {
                                                        label: 'Social Security Number',
                                                        value: ssnLast4 ? `XXX-XX-${ssnLast4}` : 'N/A',
                                                        show: true,
                                                    },
                                                    {
                                                        label: 'Address',
                                                        value: address
                                                            ? `${address.street1 || ''}${' '}
                            ${address?.street2 || ''}, ${address.city || ''}, ${address.state || ''}
                            ${address.zip || ''}`
                                                            : 'N/A',
                                                        show: true,
                                                    },
                                                ], side: "left" }), (0, jsx_runtime_1.jsx)(DetailColumn, { fields: [
                                                    {
                                                        label: 'Phone Number',
                                                        value: primaryPhone ? ((0, jsx_runtime_1.jsx)("a", { className: "email-phone-link", href: `tel:${primaryPhone}`, children: primaryPhone })) : ('N/A'),
                                                        show: true,
                                                    },
                                                    {
                                                        label: 'Alternate Phone Number',
                                                        value: ((0, jsx_runtime_1.jsx)("a", { className: "email-phone-link", href: `tel:${alternatePhone}`, children: alternatePhone })),
                                                        show: !!alternatePhone,
                                                    },
                                                    {
                                                        label: 'Email Address',
                                                        value: email ? ((0, jsx_runtime_1.jsx)("a", { className: "email-phone-link", href: `mailto:${email}`, children: email })) : ('N/A'),
                                                        show: true,
                                                    },
                                                ], side: "right" })] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "card-border__no-top pad-t-15 pad-30 flex dir-col align-start justify-between", children: [(0, jsx_runtime_1.jsxs)("div", { className: "w100 flex dir-row justify-between align-center account-and-new-sale-button mar-b-4", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex dir-col min-width-50", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex dir-row", children: [(0, jsx_runtime_1.jsxs)(components_1.P, { variant: "body-large", className: "flex align-center mar-right-8 mar-b-0", bold: true, children: ["Account Number", ' '] }), (0, jsx_runtime_1.jsx)(components_1.AccountNumber, { accountNumberString: alphaeonAccountNumber, fontVariant: "body-large" })] }), (0, jsx_runtime_1.jsxs)(components_1.P, { variant: "body-large", children: [(0, jsx_runtime_1.jsx)("strong", { children: "Product" }), (0, jsx_runtime_1.jsx)("span", { className: "m-l-5 capitalize", children: productType })] })] }), (0, jsx_runtime_1.jsx)("div", { children: lenderCanProcessSale && ((0, jsx_runtime_1.jsx)(components_2.NewSaleButton, { derogatoryInd: derogatoryInd, lenderSettings: lenderSettings, internalRiskReason: internalRiskReason, authorizedBuyers: authorizedBuyers, lenderEnabled: lenderEnabled, setSaleInitiatorAccountMemberIdCallback: setSaleInitiatorAccountMemberId, availableCreditLimit: availableCreditLimit, alphaeonAccountNumber: alphaeonAccountNumber, accountDetail: accountDetail, locationId: currentLocation.locationId })) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "w100 flex dir-row justify-between", children: [(0, jsx_runtime_1.jsx)(DetailColumn, { fields: [
                                                    {
                                                        label: CREDIT_LIMIT_TEXT,
                                                        value: (0, utils_1.formatCurrency)(creditLimit, 2),
                                                        show: true,
                                                    },
                                                    {
                                                        label: 'Date Opened',
                                                        value: createdAt
                                                            ? (0, utils_1.formatISODateStringAsUSMonthDayYear)(createdAt) ?? 'N/A'
                                                            : 'N/A',
                                                        show: lenderName !== 'ADS',
                                                    },
                                                    {
                                                        label: 'Service Date',
                                                        value: serviceDate
                                                            ? (0, utils_1.formatISODateStringAsUSMonthDayYear)(serviceDate) ??
                                                                'N/A'
                                                            : 'N/A',
                                                        show: (lenderName === 'Imprint' || lenderName === 'AFF') &&
                                                            !!serviceDate,
                                                    },
                                                    {
                                                        label: 'Authorized Buyer(s)',
                                                        value: (0, jsx_runtime_1.jsx)(components_1.AuthorizedBuyers, { authBuyers: authorizedBuyers }),
                                                        show: lenderName === 'ADS' &&
                                                            !(0, lodash_1.isNil)(authorizedBuyers) &&
                                                            authorizedBuyers.length > 0,
                                                    },
                                                ], side: "left" }), (0, jsx_runtime_1.jsx)(DetailColumn, { fields: [
                                                    {
                                                        label: CREDIT_TEXT,
                                                        value: (0, utils_1.formatCurrency)(availableCreditLimit, 2),
                                                        show: lenderName === 'ADS',
                                                    },
                                                    {
                                                        label: 'Increase Credit Limit',
                                                        value: ((0, jsx_runtime_1.jsx)(core_1.Tooltip, { enterTouchDelay: 0, title: (0, jsx_runtime_1.jsxs)(components_1.P, { variant: "body-medium", className: "font-white", children: ["Please have the patient contact Comenity Bank at", ' ', config_1.CONTACT_NUMBER, " to request a credit limit increase."] }), children: (0, jsx_runtime_1.jsx)(core_1.IconButton, { className: "icon-button", children: (0, jsx_runtime_1.jsx)(Info_1.default, { style: { color: colors_1.blue[800] } }) }) })),
                                                        show: lenderName === 'ADS',
                                                    },
                                                    {
                                                        label: 'Down Payment Required',
                                                        value: downpaymentRequired ? 'Yes' : 'No',
                                                        show: lenderName === 'Imprint' || lenderName === 'AFF',
                                                    },
                                                    {
                                                        label: 'Expiration Date',
                                                        value: expiresAt
                                                            ? (0, utils_1.formatISODateStringAsUSMonthDayYear)(expiresAt) ?? 'N/A'
                                                            : 'N/A',
                                                        show: lenderName === 'Imprint' || lenderName === 'AFF',
                                                    },
                                                ], side: "right" })] })] })] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "account-lookup", children: [(0, jsx_runtime_1.jsxs)("h1", { children: [consumerCreditInstrumentType === 'installment'
                                ? 'Account'
                                : 'Transaction', ' ', "History"] }), (0, jsx_runtime_1.jsx)("p", { className: "sub-title", children: "Account history will only display the transactions for the currently selected location." }), (0, jsx_runtime_1.jsxs)("div", { className: "transaction-summary summary w-80 m-b-50 ", children: [transactions?.length === 0 &&
                                consumerCreditInstrumentType === 'installment' && ((0, jsx_runtime_1.jsx)("div", { className: "empty-transaction-card", children: "No past account history" })), consumerCreditInstrumentType === 'installment' &&
                                transactions &&
                                transactions.map((transaction, index) => transaction.transactionType == 'loan' && ((0, jsx_runtime_1.jsx)(merchant_portal_components_1.LoanCard, { transaction: transaction, accountDetail: accountDetail, withCancel: !isServiceDateInFuture(transaction.effectiveAt ?? ''), handleCancelOrRefund: refundTransaction }, index))), (0, jsx_runtime_1.jsxs)("div", { className: "voidable-transactions", children: [salesTransactions &&
                                        salesTransactions.map((transaction, index) => index < salesTransactionsRendered ? ((0, jsx_runtime_1.jsx)(merchant_portal_components_1.TransactionCard, { transaction: transaction, accountDetail: accountDetail, refundTransaction: refundTransaction, voidTransaction: voidTransaction, callback: reloadFunc }, index)) : ((0, jsx_runtime_1.jsx)("div", {}, index))), (0, jsx_runtime_1.jsx)("div", { ref: salesIntersection }), salesTransactions && salesTransactions.length > 0 && ((0, jsx_runtime_1.jsxs)("p", { className: "text-center voidable-transactions__void-helper", children: ["Void available up until 9:59 PM EST the day of a transaction.", (0, jsx_runtime_1.jsx)("br", {}), "Funds will be released back to the account owner\u2019s Alphaeon Card."] }))] }), (0, jsx_runtime_1.jsx)("div", { className: "refundable-transactions", children: refundTransactions &&
                                    refundTransactions.map((transaction, index) => transaction.transactionType != 'loan' &&
                                        (index < refundTransactionsRendered ? ((0, jsx_runtime_1.jsx)(merchant_portal_components_1.TransactionCard, { transaction: transaction, accountDetail: accountDetail, refundTransaction: refundTransaction, voidTransaction: voidTransaction }, index)) : ((0, jsx_runtime_1.jsx)("div", {}, index)))) })] })] }), (0, jsx_runtime_1.jsx)("div", { ref: refundsIntersection })] }));
}
function mapStateToProps(state) {
    return {
        currentLocation: reducer_1.selectors.currentLocation(state),
        lenderSettings: reducer_1.selectors.lenderSettings(state),
    };
}
const mapDispatchToProps = {};
const mapApiAuthToProps = {
    getLenderSettings: apiActions.getLenderSettings,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, utils_1.withApiAuth)(mapApiAuthToProps))(AccountLookUpDetail);
function assemble(transactions) {
    const table = {};
    transactions.forEach((transaction) => {
        if (!table[transaction.refundedTransactionId]) {
            table[transaction.refundedTransactionId] = [];
        }
        table[transaction.refundedTransactionId].push(transaction);
    });
    const result = [];
    const constructResult = (key) => {
        if (table[key]) {
            table[key].forEach((transaction) => {
                result.push(transaction);
                constructResult(transaction.transactionId);
            });
        }
    };
    constructResult(null);
    return result;
}
const DetailColumn = ({ fields, side, }) => {
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)({
            'flex dir-col': true,
            'mar-right-8': side === 'left',
        }), children: fields.map((field, index) => field.show && ((0, jsx_runtime_1.jsx)("div", { className: "w100 flex dir-row justify-between pad-y-4", children: (0, jsx_runtime_1.jsxs)(components_1.P, { variant: "body-large", children: [(0, jsx_runtime_1.jsx)(components_1.Span, { bold: true, variant: "body-large", className: "m-r-5", children: field.label }), field.value] }) }, index))) }));
};
